// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__31u4d","rootSmall":"AddTileButton_rootSmall__1D70A"};